import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getVar } from "config";

export enum LoadingState {
  NOT_STARTED,
  LOADING,
  LOADED,
}

export type AppVersionState = {
  loadingState: LoadingState;
  deployedVersion: null | string;
  currentVersion: null | string;
};

export const initialState: AppVersionState = {
  loadingState: LoadingState.NOT_STARTED,
  currentVersion: getVar("REACT_APP_VERSION") ?? null,
  deployedVersion: null,
};

export const appVersionSlice = createSlice({
  name: "appVersion",
  initialState,
  reducers: {},
  extraReducers: {
    "appVersion/fetchDeployedVersion/pending": (state) => {
      state.loadingState = LoadingState.LOADING;
    },
    "appVersion/fetchDeployedVersion/fulfilled": (
      state,
      action: PayloadAction<string>,
    ) => {
      state.loadingState = LoadingState.LOADED;
      state.deployedVersion = action.payload;
    },
    "appVersion/fetchDeployedVersion/rejected": (state) => {
      state.loadingState = LoadingState.LOADED;
      state.deployedVersion = null;
    },
  },
});

export default appVersionSlice.reducer;
